import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: start;

  @media (max-width: 768px) {
    padding-bottom: 24px;
  }
`;

export const FormFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 33px;
  width: 100%;

  & > button {
    width: 167px;
  }

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  gap: 2px;
  align-self: flex-start;

  span {
    font-size: 11px;
    line-height: 180%;
    color: ${colors.text['sub-500']};
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 184px);
  grid-template-rows: repeat(3, 78px);
  gap: 24px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;
